import React from 'react'
import { Dialog, DialogTitle } from '@material-ui/core'
import { Formik } from 'formik'
import { DataChartModalForm } from './DataChartModalForm'
import { dataChartModalFormSchema } from './validation'

export interface IDataChartModal {
  open: boolean
  isLoading?: boolean
  title: string
  dataStreamURI: string
  actionLabel?: string
  handleClose: () => void
  handleSubmit: (fileName: string) => void
}

export const DataChartModal = ({
  open,
  title,
  dataStreamURI,
  isLoading,
  handleClose,
  handleSubmit,
}: IDataChartModal) => (
  <Dialog
    fullWidth
    disableBackdropClick
    maxWidth="sm"
    open={open}
    onClose={handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <Formik
      initialValues={{
        fileName: 'DataStream Chart',
      }}
      onSubmit={(values) => {
        handleSubmit(values.fileName.trim())
      }}
      render={(formikProps) => (
        <DataChartModalForm
          formikProps={formikProps}
          showThumbnail={true}
          fileTemporaryURL={dataStreamURI}
          handleClose={handleClose}
          isLoading={isLoading}
        />
      )}
      validationSchema={dataChartModalFormSchema}
    />
  </Dialog>
)
